import IconPathMap from "./iconography";

export default function GridPlotLegend(
   userTheme,
   plotConfigs,
   series,
   legendHeight,
   palette,
) {
   let legendData;
   if (series.every((s) => s.type === "pie")) {
      legendData = series.reduce((acc, val) => {
         const categories = val.data.reduce((dataAcc, dataVal) => {
            if (dataAcc.length === 0) {
               dataAcc.push({
                  name: dataVal.name,
                  icon: `path://${IconPathMap("pie")}`,
               });
            } else {
               if (!dataAcc.find((a) => a.name === dataVal.name)) {
                  dataAcc.push({
                     name: dataVal.name,
                     icon: `path://${IconPathMap("pie")}`,
                  });
               }
            }
            return dataAcc;
         }, []);
         acc.push(categories);
         acc.flat();
         return acc;
      }, []);
   } else {
      legendData = series.map((s) => {
         let icon;
         switch (s.type) {
            case "line":
               if (s.areaStyle) {
                  //FA6 Chart-Area
                  icon = IconPathMap("area");
               } else {
                  //FA6 Chart-line
                  icon = IconPathMap("line");
               }
               break;
            case "bar": //FA6 Chart-bar
               icon = IconPathMap("bar");
               break;
            case "heatmap": //FA6 Temperature-half
               icon = IconPathMap("heatmap");
               break;
            case "scatter": //FA6 Circle
               icon = IconPathMap("scatter");
               break;
            default: //FA6 Square
               icon = IconPathMap("box");
         }
         return {
            name: s.name,
            icon: `path://${icon}`,
         };
      });
   }

   return {
      type: "scroll",
      left: 20, //Left Padding
      top: 5,
      padding: 6,
      borderRadius: 10, //Matches everything else
      selectorItemGap: 8,
      selectorButtonGap: 12,
      tooltip: {
         show: true,
         backgroundColor: userTheme === "Dark" ? "black" : "white",
         textStyle: {
            color: userTheme === "Dark" ? "white" : "black",
         },
         formatter: function (params) {
            //CurrentConfig will find the plotconfig related to this formatter
            const currentConfig = plotConfigs.find((p) => {
               return p.series.find((series) => {
                  return params.name === series.name;
               });
            });
            if (currentConfig) {
               const currentSeries = currentConfig.series.find((s) => {
                  return params.name === s.name;
               });
               const seriesIndex = series.findIndex(
                  (a) =>
                     (a.name === currentSeries.name &&
                        a.type === currentSeries.type) ||
                     (a.name === currentSeries.name &&
                        currentSeries.yAxisIndex === a.yAxisIndex &&
                        currentSeries.xAxisIndex === a.xAxisIndex),
               );

               return `<div class="tooltip-container" style="border:1px solid ${palette[seriesIndex % palette.length]}; margin: -12px">
                                <div class="tooltip-header"> 
                                    <div class="tooltip-row> 
                                        <p class="echarts-legend-description">
                                            ${currentSeries?.description ? currentSeries.description : currentSeries.name}
                                        </p>
                                    </div>
                                </div>
                            </div>`;
            }
            //Except for pie charts, then the rules are different
            return `<div class="tooltip-container" style="margin: -12px">
                            <div class="tooltip-header"> 
                                <div class="tooltip-row> 
                                    <p class="echarts-legend-description">${params.name}</p>
                                </div>
                            </div>
                        </div>`;
         },
      },
      data: legendData.flat(),
      itemHeight: Math.ceil(legendHeight / 2.5) + 2,
      textStyle: {
         color: userTheme === "Dark" ? "white" : "black",
         fontSize: Math.ceil(legendHeight / 2.5),
         lineHeight: 0.5,
      },
      inactiveColor: userTheme === "Dark" ? "#CDCDCD" : "#4F4C4D",
      backgroundColor: userTheme === "Dark" ? "#191919" : "white",
   };
}
